import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var DEFAULT_VARIANT = "default";
var VARIANTS_BACKGROUND_COLORS_MAPPING = {
  default: "bg-link",
  transparent: "bg-transparent",
  neutral: "bg-light",
  danger: "bg-danger",
  warning: "bg-warning",
  success: "bg-success"
};
var VARIANTS_COLORS_MAPPING = {
  default: "text-lightest",
  transparent: "text-secondary",
  neutral: "text-body",
  danger: "text-lightest",
  warning: "text-body",
  success: "text-lightest"
};
var StatusLabel = function StatusLabel(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? DEFAULT_VARIANT : _b,
    children = _a.children;
  var labelClassNames = classNames(["py-xs", "px-sm", "font-bold", "rounded-base", "inline-block", "whitespace-nowrap", "text-xs", "auto-qa-label", "uppercase", "tracking-wider", getTextColor(variant), getBackgroundColor(variant)]);
  return /*#__PURE__*/React.createElement("span", {
    className: labelClassNames
  }, children);
};
function getTextColor(variant) {
  return VARIANTS_COLORS_MAPPING[variant];
}
function getBackgroundColor(variant) {
  return VARIANTS_BACKGROUND_COLORS_MAPPING[variant];
}
StatusLabel.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS_COLORS_MAPPING)),
  children: PropTypes.node.isRequired
};

export { StatusLabel };
//# sourceMappingURL=index.es.js.map
